"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/** The list of the types that easy to the motivated environment. */
exports.default = Object.freeze([
    'competition',
    'ownMind',
    'power',
    'safety',
    'skillUp',
    'status',
]);
//# sourceMappingURL=motivation.js.map